import { StoryblokComponent } from '@storyblok/react';

import {
  FooterBottomSectionLeft,
  FooterBottomSectionRight,
  FooterBottomSectionWrapper,
} from './FooterBottomSection.style';
import { FooterBottomSectionProps } from './FooterBottomSection.types';

export const FooterBottomSection = ({ leftContent, rightContent }: FooterBottomSectionProps) => {
  return (
    <FooterBottomSectionWrapper>
      <FooterBottomSectionLeft>
        {!!leftContent?.length &&
          leftContent?.map((content) => <StoryblokComponent key={content?._uid} blok={content} />)}
      </FooterBottomSectionLeft>

      <FooterBottomSectionRight>
        {!!rightContent?.length &&
          rightContent?.map((content) => <StoryblokComponent key={content?._uid} blok={content} />)}
      </FooterBottomSectionRight>
    </FooterBottomSectionWrapper>
  );
};
